import Crud from "../Crud";
import { lightGreen } from "@mui/material/colors";

/**
 * Static helper functions related to ProductTypes.
 */
export default class ProductType extends Crud {
  /**
   * @param {object} productType The productType object.
   * @returns The display name of the productType.
   */
  static getDisplayName(productType) {
    return productType ? productType.name : null;
  }

  /**
   * Determines if a productType matches a search query.
   *
   * @param {object} productType The productType to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the productType matches the query.
   */
  static match(productType, query) {
    return (
      (productType.name !== null &&
        productType.name.toLowerCase().includes(query)) ||
      productType.id === +query
    );
  }

  /**
   * @param {array} productTypes The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(productTypes) {
    return productTypes.sort((a, b) => {
      // Sort by sortOrder first (null values to end), then by name
      const aHasSortOrder = a.sortOrder !== null && a.sortOrder !== undefined;
      const bHasSortOrder = b.sortOrder !== null && b.sortOrder !== undefined;

      if (aHasSortOrder && bHasSortOrder) {
        const sortOrderDiff = Number(a.sortOrder) - Number(b.sortOrder);
        return sortOrderDiff !== 0
          ? sortOrderDiff
          : a.name.localeCompare(b.name);
      } else if (aHasSortOrder) {
        return -1;
      } else if (bHasSortOrder) {
        return 1;
      }

      return a.name.localeCompare(b.name);
    });
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return lightGreen;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "Inventory";
  }

  /**
   * @param {object} productType
   * @returns {boolean} Whether or not this productType is complex;.
   */
  static isComplex(productType) {
    return productType && productType.name.toLowerCase().includes("complex");
  }
}
